import { useRef } from "react";

export const useSkipFirstRender = (): (() => boolean) => {
  const isFirstRender = useRef<boolean>(true);

  const skipFirstRender = (): boolean => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return true;
    }
    return false;
  };

  return skipFirstRender;
};
